{
  "name": "88-note Piano Scordatura Template",
  "description": "8800.0 cents divided into 88 equal steps. Template for retuning piano keys one by one.",
  "scale": [
    "100.0",
    "200.0",
    "300.0",
    "400.0",
    "500.0",
    "600.0",
    "700.0",
    "800.0",
    "900.0",
    "1000.0",
    "1100.0",
    "1200.0",
    "1300.0",
    "1400.0",
    "1500.0",
    "1600.0",
    "1700.0",
    "1800.0",
    "1900.0",
    "2000.0",
    "2100.0",
    "2200.0",
    "2300.0",
    "2400.0",
    "2500.0",
    "2600.0",
    "2700.0",
    "2800.0",
    "2900.0",
    "3000.0",
    "3100.0",
    "3200.0",
    "3300.0",
    "3400.0",
    "3500.0",
    "3600.0",
    "3700.0",
    "3800.0",
    "3900.0",
    "4000.0",
    "4100.0",
    "4200.0",
    "4300.0",
    "4400.0",
    "4500.0",
    "4600.0",
    "4700.0",
    "4800.0",
    "4900.0",
    "5000.0",
    "5100.0",
    "5200.0",
    "5300.0",
    "5400.0",
    "5500.0",
    "5600.0",
    "5700.0",
    "5800.0",
    "5900.0",
    "6000.0",
    "6100.0",
    "6200.0",
    "6300.0",
    "6400.0",
    "6500.0",
    "6600.0",
    "6700.0",
    "6800.0",
    "6900.0",
    "7000.0",
    "7100.0",
    "7200.0",
    "7300.0",
    "7400.0",
    "7500.0",
    "7600.0",
    "7700.0",
    "7800.0",
    "7900.0",
    "8000.0",
    "8100.0",
    "8200.0",
    "8300.0",
    "8400.0",
    "8500.0",
    "8600.0",
    "8700.0",
    "0."
  ],
  "key_colors_mode": "manual",
  "short_description": "12edo|12-tone-ET",
  "built_in_group": "Scordatura",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "a0",
    "*sa|*fb",
    "b0",
    "c1",
    "*sc|*fd",
    "d1",
    "*sd|*fe",
    "e1",
    "f1",
    "*sf|*fg",
    "g1",
    "*sg|*fa",
    "a1",
    "*sa|*fb",
    "b1",
    "c2",
    "*sc|*fd",
    "d2",
    "*sd|*fe",
    "e2",
    "f2",
    "*sf|*fg",
    "g2",
    "*sg|*fa",
    "a2",
    "*sa|*fb",
    "b2",
    "c3",
    "*sc|*fd",
    "d3",
    "*sd|*fe",
    "e3",
    "f3",
    "*sf|*fg",
    "g3",
    "*sg|*fa",
    "a3",
    "*sa|*fb",
    "b3",
    "c4",
    "*sc|*fd",
    "d4",
    "*sd|*fe",
    "e4",
    "f4",
    "*sf|*fg",
    "g4",
    "*sg|*fa",
    "a4",
    "*sa|*fb",
    "b4",
    "c5",
    "*sc|*fd",
    "d5",
    "*sd|*fe",
    "e5",
    "f5",
    "*sf|*fg",
    "g5",
    "*sg|*fa",
    "a5",
    "*sa|*fb",
    "b5",
    "c6",
    "*sc|*fd",
    "d6",
    "*sd|*fe",
    "e6",
    "f6",
    "*sf|*fg",
    "g6",
    "*sg|*fa",
    "a6",
    "*sa|*fb",
    "b6",
    "c7",
    "*sc|*fd",
    "d7",
    "*sd|*fe",
    "e7",
    "f7",
    "*sf|*fg",
    "g7",
    "*sg|*fa",
    "a7",
    "*sa|*fb",
    "b7",
    "c8"
  ],
  "note_colors": [
    "#ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ff8f8f",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "c3c3d5",
    "ededf7",
    "ffb6b6"
  ],
  "equivSteps": 88,
  "fundamental": 440,
  "reference_degree": 48,
  "center_degree": 44,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 24,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 39,
  "lumatone_anchor_channel": 3
}
